export const LLM_MODELS = [
  { id: 'gpt-4.1', name: 'GPT-4.1' },
  { id: 'gpt-4.1-mini', name: 'GPT-4.1 Mini' },
  { id: 'gpt-4.1-nano', name: 'GPT-4.1 Nano' },
  { id: 'gpt-4o', name: 'GPT-4o' },
  { id: 'gpt-4o-mini', name: 'GPT-4o Mini' },
  { id: 'gpt-4-turbo', name: 'GPT-4 Turbo' },
  { id: 'gpt-3.5-turbo', name: 'GPT-3.5 Turbo' },
  { id: 'voice-agent', name: 'Voice Agent' },
  { id: '8nabler-agent', name: '8nabler Agent' },
];
export const LLM_RESPONSE_FORMAT = [
  { id: 'text', name: 'Text' },
  { id: 'json_object', name: 'JSON Object' },
];
export const LLM_SAMPLE_RATES = [
  { id: '8000', name: '8000' },
  { id: '16000', name: '16000' },
];
export const LLM_AUDIO_LANGS = [
  { id: 'en-US', name: 'English' },
  { id: 'cmn-Hans-CN', name: 'Chinese' },
  { id: 'yue-Hant-HK', name: 'Chinese,Yue' },
  { id: 'ta-IN', name: 'Tamil' },
  { id: 'id-ID', name: 'Indonesian' },
  { id: 'ms-MY', name: 'Malay' },
  { id: 'vi-VN', name: 'Vietnamese' },
  { id: 'th-TH', name: 'Thai' },
  { id: 'fil-PH', name: 'Filipino' },
];

export const LLM_LANGUAGES = [
  { id: 'ms-MY', name: 'Malay' },
  { id: 'en-US', name: 'English' },
  { id: 'cmn-Hans-CN', name: 'Chinese' },
  { id: 'yue-Hant-HK', name: 'Chinese,Yue' },
  { id: 'ta-IN', name: 'Tamil' },
  { id: 'id-ID', name: 'Indonesian' },
  { id: 'vi-VN', name: 'Vietnamese' },
  { id: 'th-TH', name: 'Thai' },
  { id: 'fil-PH', name: 'Filipino' },
];

export const LLM_LANGUAGE_TO_AUDIO_LANG_MAPPING = {
  en: 'en-US',
  zh: 'cmn-Hans-CN',
  ta: 'ta-IN',
  id: 'id-ID',
  ms: 'ms-MY',
  vi: 'vi-VN',
  th: 'th-TH',
  fil: 'fil-PH',
  eng: 'en-US',
};
